var _style, _path, _g, _g2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 409.8 120",
    style: {
      enableBackground: "new 0 0 409.8 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "appstore"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M409.8 108c.1 6.6-5.2 11.9-11.8 12H11.8C5.2 119.9 0 114.6 0 108V12C0 5.4 5.2.1 11.8 0H398c6.6.1 11.8 5.4 11.8 12v96z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    transform: "translate(126.379 50.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    className: "st0",
    d: "M24.5 29.3H10L6.4 39H0L14.2 2.7h6L34.8 39h-6.7l-3.6-9.7zm-12.7-4.8h10.9l-3.9-10.3c-.6-1.5-.9-3-1.5-4.8-.6 1.5-.9 3-1.5 4.8l-4 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "st0",
    d: "M37.5 18.8c0-2.2-.1-4.4-.3-6.7H43c.2 1.1.4 2.2.3 3.3 2-2.5 5-3.9 8.2-3.9 1.8.1 3.6.6 5.1 1.5 1.6 1 2.8 2.5 3.6 4.2 1.1 2.4 1.6 5 1.5 7.6 0 2.8-.5 5.6-1.5 8.2-1.1 2-2.6 3.8-4.5 5.1-2 1.2-4.3 1.9-6.6 1.8-1.9 0-3.7-.3-5.4-.9v11.2l-6 .6-.2-32zm16.3 13.6c1.2-1.8 1.8-4.2 1.8-7.6.1-2.3-.4-4.6-1.5-6.7-2-2-5.1-2.4-7.6-.9-1.1.6-2.2 1.4-3 2.4v14.5c.6.4 1.4.6 2.1.6.9 0 1.5.3 2.4.3 2.8.1 4.6-.8 5.8-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    className: "st0",
    d: "M65.9 18.8c0-2.2-.1-4.4-.3-6.7h5.7c.2 1.1.4 2.2.3 3.3 2-2.5 5-3.9 8.2-3.9 1.8.1 3.6.6 5.1 1.5 1.6 1 2.8 2.5 3.6 4.2 1.1 2.4 1.6 5 1.5 7.6 0 2.8-.5 5.6-1.5 8.2-1.1 2-2.6 3.8-4.5 5.1-2 1.2-4.3 1.9-6.6 1.8-1.9 0-3.7-.3-5.4-.9v11.2l-6 .6-.1-32zm16.4 13.6c1.2-1.8 1.8-4.2 1.8-7.6.1-2.3-.4-4.6-1.5-6.7-1-1.3-2.6-2.1-4.2-2.1-1.2 0-2.3.3-3.3.9-1.1.6-2.2 1.4-3 2.4v14.5c.6.4 1.4.6 2.1.6.9 0 1.5.3 2.4.3 2.7.4 4.5-.5 5.7-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "st0",
    d: "M102.2 37.2c-2.7-1.4-4.8-3.6-6.1-6.4-1.5-3-2.2-6.3-2.1-9.7-.1-3.6.8-7.1 2.4-10.3 1.6-2.7 3.9-4.9 6.7-6.4 3-1.5 6.3-2.2 9.7-2.1 2 .1 4.1.3 6.1.6 2.1.3 3.6 1.2 5.4 1.8l-1.5 4.8c-2.9-1.5-6.1-2.3-9.4-2.4-2.3 0-4.6.5-6.7 1.5-1.9 1.2-3.4 2.9-4.5 4.8-1 2.4-1.5 5-1.5 7.6-.1 2.4.3 4.8 1.2 7 .8 2 2.2 3.7 3.9 4.8 2 1.3 4.3 1.9 6.7 1.8 1.2.1 2.4-.1 3.6-.3 1.2-.3 2.4-.6 3.3-.9v-7.3H111v-4.8h14.5v15.1c-2.1 1-4.3 1.7-6.7 2.1-2.2.6-4.4.9-6.7.9-3.4.3-6.8-.5-9.9-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    className: "st0",
    d: "M147.3 39c-.3-1.2-.4-2.4-.3-3.6-1 1.2-2.2 2.3-3.6 3-1.6.9-3.4 1.3-5.1 1.2-1.5 0-2.9-.3-4.2-.9-1.3-.6-2.3-1.5-3-2.7-.8-1.4-1.2-3-1.2-4.5-.1-2.4.9-4.8 2.7-6.4 1.8-1.5 5.1-2.4 9.4-2.4 1.6-.1 3.2 0 4.8.3v-.6c.1-1.8-.4-3.7-1.5-5.1-1.2-1-2.7-1.6-4.2-1.5-1.4.1-2.8.3-4.2.6-1.4.3-2.7.8-3.9 1.5l-.9-4.5c1.4-.6 2.8-1.1 4.2-1.5 1.9-.4 3.8-.6 5.7-.6 2.1-.1 4.2.3 6.1 1.2 1.7.7 3.1 2 3.9 3.6 1.1 2.2 1.6 4.6 1.5 7V34c0 1.7.1 3.4.3 5.1l-6.5-.1zm-3.6-4.8c1.2-.6 2.2-1.4 3-2.4v-5.1c-1.4-.2-2.8-.3-4.2-.3-2.4 0-4.2.3-5.4 1.2-1 .8-1.5 2-1.5 3.3-.1 1.1.3 2.3 1.2 3 .9.7 1.9 1 3 .9 1.3.2 2.7 0 3.9-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    className: "st0",
    d: "M158.2 32.7V.6l6.1-.6v31.5c0 .8.2 1.7.6 2.4.3.6.9.6 1.8.6.5 0 1-.1 1.5-.3l.6 4.5-2.1.6c-.9 0-1.5.3-2.4.3-4 0-6.1-2.4-6.1-6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st0",
    d: "M173.6 32.7V.6l6.1-.6v31.5c0 .8.2 1.7.6 2.4.3.6.9.6 1.8.6.5 0 1-.1 1.5-.3l.6 4.5-2.1.6c-.9 0-1.5.3-2.4.3-3.9 0-6.1-2.4-6.1-6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st0",
    d: "M210.2 26.3h-17.5c.3 5.7 3 8.5 8.2 8.5 1.3-.1 2.6-.3 3.9-.6 1.3-.3 2.7-.7 3.9-1.2l1.2 4.2c-3.2 1.5-6.7 2.2-10.3 2.1-2.5 0-5-.5-7.3-1.5-1.9-1.1-3.4-2.7-4.5-4.5-1-2.3-1.5-4.8-1.5-7.3 0-2.6.5-5.2 1.5-7.6.8-2.1 2.5-3.9 4.5-4.8 3.9-2.4 8.8-2.4 12.7 0 1.8 1.2 3.1 2.9 3.9 4.8.9 2.1 1.3 4.4 1.2 6.7v1.2zm-6-3.9c.1-1.7-.5-3.4-1.5-4.8-.9-1.2-2.1-1.5-3.9-1.5-1.5 0-2.9.5-3.9 1.5-1.1 1.4-1.8 3.1-2.1 4.8h11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    className: "st0",
    d: "M215.4 18.8c0-2.2-.1-4.4-.3-6.7h5.7c0 .6.3 1.5.3 2.7 0 .9.3 1.8.3 2.4.6-1.1 1.3-2.1 2.1-3 .7-.9 1.5-1.6 2.4-2.1.9-.6 2-.9 3-.9.8-.1 1.6 0 2.4.3l-.9 5.4c-.7-.3-1.4-.4-2.1-.3-1.4-.1-2.8.4-3.9 1.2-1.3 1-2.5 2.2-3.3 3.6v17.2h-6v-20h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    className: "st0",
    d: "m235.4 50.2-2.1-.6 1.2-4.5 1.5.3c.6 0 1.2.3 1.8.3 2.7 0 4.8-1.8 6.1-5.1l.3-.9-10-27.2h6.7l5.1 15.1c.6 2 1.2 4 1.5 6 .6-1.8.9-3.9 1.5-5.7l5.1-15.4h6.4l-10 27.2c-.7 2.3-1.7 4.4-3 6.4-1.1 1.4-2.4 2.7-3.9 3.6-1.7.9-3.6 1.3-5.4 1.2-1-.5-1.9-.7-2.8-.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    transform: "translate(126.379 18.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    className: "st0",
    d: "M0 0h11.2l-.3 2.7H3.3v5.1h7.3v2.4H3.3V16h7.9l-.3 2.7H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    className: "st0",
    d: "M18.8 9.4 13 0h3.6l3.9 7 4.2-7h3.6l-5.7 9.1 6.4 9.7h-3.6l-4.5-7.6-4.5 7.6h-3.9l6.3-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    className: "st0",
    d: "M31.2 0h5.1c1.9-.1 3.8.4 5.4 1.5 1.2 1 1.9 2.6 1.8 4.2 0 1.2-.3 2.3-.9 3.3-.7.9-1.5 1.6-2.4 2.1-.9.6-2.1.6-3.6.6-.8 0-1.6-.1-2.4-.3v7.3h-3.3V0h.3zm8.1 8.5c.7-.7 1-1.7.9-2.7 0-1.2-.3-2.1-1.2-2.4-.9-.7-1.9-1-3-.9h-1.8v6.7c.6 0 1.2.1 1.8.3 1.8.2 2.7-.1 3.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    className: "st0",
    d: "M46.9 0h3.3v16h7.9l-.3 3H46.9V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    className: "st0",
    d: "M62.9 18.1c-1.4-.7-2.4-1.9-3-3.3-.8-1.6-1.2-3.4-1.2-5.1-.1-1.8.3-3.6 1.2-5.1.7-1.5 1.9-2.6 3.3-3.3C64.8.4 66.6 0 68.3.1c1.7-.1 3.4.3 4.8 1.2 1.4.7 2.4 1.9 3 3.3.7 1.5 1.1 3.2 1.2 4.8.1 1.9-.3 3.8-1.2 5.4-.7 1.5-1.9 2.6-3.3 3.3-1.6.9-3.3 1.3-5.1 1.2-1.6.1-3.3-.3-4.8-1.2zm8.8-2.4c.9-.7 1.6-1.5 2.1-2.4.3-1.2.5-2.4.6-3.6 0-1.2-.2-2.5-.6-3.6-.2-1-.9-1.9-1.8-2.4-2.1-1.2-4.6-1.2-6.7 0-.9.7-1.7 1.6-2.1 2.7-.5 1.1-.7 2.4-.6 3.6 0 1.2.2 2.5.6 3.6.4 1.1 1.1 1.9 2.1 2.4 1 .6 2.2.9 3.3.9 1.1-.3 2.1-.7 3.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    className: "st0",
    d: "M81.4 0h6.1c2.1 0 3.9.3 4.8 1.2 1.2.8 1.9 2.2 1.8 3.6-.1.9-.3 1.9-.6 2.7-.3.8-.8 1.5-1.5 1.9-.5.5-1.1.9-1.8 1.2l5.7 8.5H92l-4.8-7.6h-2.4v7.6h-3.3V0zm5.1 9.1c.7 0 1.5-.2 2.1-.6.6-.2 1.2-.7 1.5-1.2.3-.6.5-1.2.6-1.8 0-.8-.3-1.6-.9-2.1-.8-.4-1.8-.6-2.7-.6h-2.4v6.4l1.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    className: "st0",
    d: "M98.3 0h11.2l-.3 2.7h-7.6v5.1h7.3v2.4h-7.3V16h7.9l-.3 3H98.3V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    className: "st0",
    d: "M121.6 0h3.3v19.1h-3.3V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    className: "st0",
    d: "M133.4 3h-5.7l.3-2.7h14.8l-.3 2.7H137v16.3h-3.6V3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    className: "st0",
    d: "M157 18.1c-1.4-.7-2.4-1.9-3-3.3-.8-1.6-1.2-3.4-1.2-5.1-.1-1.8.3-3.6 1.2-5.1.7-1.5 1.9-2.6 3.3-3.3 1.6-.9 3.4-1.3 5.1-1.2 1.7-.1 3.4.3 4.8 1.2 1.4.7 2.4 1.9 3 3.3.7 1.5 1.1 3.2 1.2 4.8.1 1.9-.3 3.8-1.2 5.4-.7 1.5-1.9 2.6-3.3 3.3-1.6.9-3.3 1.3-5.1 1.2-1.7.2-3.3-.3-4.8-1.2zm8.5-2.4c.9-.7 1.6-1.5 2.1-2.4.3-1.2.6-2.4.6-3.6 0-1.2-.2-2.5-.6-3.6-.2-1-.9-1.9-1.8-2.4-2.1-1.2-4.6-1.2-6.7 0-.9.7-1.7 1.6-2.1 2.7-.5 1.1-.7 2.4-.6 3.6 0 1.2.2 2.5.6 3.6.4 1.1 1.1 1.9 2.1 2.4 1 .6 2.2.9 3.3.9 1.1-.2 2.1-.6 3.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    className: "st0",
    d: "M175.2 0h3.6l9.4 14.5V0h3v19.1h-3.6l-9.4-14.8v14.8h-3V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    transform: "translate(22.922 18.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6_1_\\u62F7\\u8D1D_25_32_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M57.5 0H22.4C6.1 0 0 6 0 22.4v34.8c0 16.3 6.1 22.4 22.4 22.4h34.8c16.3 0 22.4-6.1 22.4-22.4V22.4C79.9 6 73.8 0 57.5 0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#c8102e"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    className: "st0",
    d: "M15.7 39.9h2.1v10.6h-2.1v-4.2h-4.5v4.2H9.1V39.9h2.1v4.2H16v-4.2h-.3zM27.8 46c0 1.8-.9 2.7-2.4 2.7S23 47.8 23 46v-6h-2.1v6c0 3 1.5 4.5 4.5 4.5 2.7 0 4.5-1.8 4.5-4.8V40h-2.1v6zm24.5 1.2-2.4-7.3h-1.8l-2.4 7.3-2.1-7.3h-2.1l3.6 10.6h1.8l2.4-7 2.4 7h1.8l3.6-10.6H55l-2.7 7.3zm8.2-1.2h3.9v-1.8h-3.9V42h5.4v-2.1h-7.6v10.3h7.9v-1.8h-5.7V46zm8.5 4.2h2.1V39.9H69v10.3zm-34.8-2.1-.9 2.1h-2.1l4.5-10.3h1.8L42 50.2h-2.1l-.9-2.1h-4.8zm.6-1.8h3.3l-1.5-3.6-1.8 3.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    className: "st0",
    d: "M39.9 26.6c-7.3-.1-13.2-6-13.3-13.3h1.8c-.2 6.3 4.8 11.6 11.2 11.8 6.4.2 11.6-4.8 11.8-11.1v-.6h1.8c0 7.2-5.9 13.2-13.3 13.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppGallery);
export default __webpack_public_path__ + "static/media/app-gallery.5336b1eae552f34ddb58a183f816f7f1.svg";
export { ForwardRef as ReactComponent };